import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

import { getGeneralInfo } from '@api/store/account/actions';
import EmailApiSurvey2023 from '../config/emailapi-2023.json';
import EmailApiSurvey2025 from '../config/emailapi-2025.json';
import { find } from 'lodash-es';
import { AccountOptions } from '@dev/ee-api/ee-api-models';

export const useGetSurveyVariant = () => {
    const { DateCreated, Options } = useSelector(getGeneralInfo);

    const onboardingSurveyStartDate = '2024-03-26';
    const showSurveyForOnboardingByDate = dayjs(DateCreated).utc(true).endOf('D').isAfter(dayjs(onboardingSurveyStartDate).endOf('D'));

    const surveyVariant = [
        {
            content: EmailApiSurvey2025,
            variantAvailable: showSurveyForOnboardingByDate && Options?.includes(AccountOptions.RequireOnboardingProcess),
        },
    ];

    return find(surveyVariant, (variant) => variant?.variantAvailable)?.content || EmailApiSurvey2023;
};
